module.exports = __webpack_public_path__ + "img/link.9815a5ac.svg";